import {
    LOADING_SCREEN_SHOW,
    LOADING_SCREEN_HIDE,
    SET_CUSTOMER_DATA,
    SET_CLAIM_DATA,
    MODAL_SHOW,
    MODAL_TYPE_OK,
    MODAL_TYPE_ERROR,
    MODAL_GET_BACK_TO_YOU,
    MODAL_TYPE_GET_BACK_DAMAGE,
    MODAL_TYPE_INTERVENTION,
    POLICY_LOAD_VIEW_SCREEN_HIDE,
    POLICY_LOAD_VIEW_SCREEN_SHOW,
    MODAL_TYPE_NAM_OK,
    POLICY_COVER_ITEM,
    QUOTED_COVER_ITEM,
    EMPTY_GUID
} from "../constants/constants";
import {
    PROFILE_SHOW, PROFILE_HIDE,
    FIELD_PHONENUMBER,
    FIELD_ALTPHONENUMBER,
    FIELD_EMAIL,
    FIELD_PREFERREDLANGUAGE,
} from "../constants/constants";
import { CALL_YOU_ASAP, WELL_CALL_YOU_SOON, UPDATE_CUSTOMER_INFO_SUCCESS, ERROR_HEADER, DOCUMENT_SUCCESSFULLY_SENT, ERROR_SOMETHING_WENT_WRONG, CALL_BACK_REQUEST, CALL_ASAP, CALL_BACK, NAM_CLAIM_THANK_YOU_CALL_BACK, NAM_CLAIM_CALLBACK_BUSINESS_HOURS_HEADING, NAM_CLAIM_CALLBACK_BUSINESS_HOURS } from "../constants/copy";
import { postToController, logErrorToDatabase } from "./apiActions";
import { logEvent } from "../firebase/firebase";
import { getClaimProgress, getNextProgressStepName, setLoadingAndEmpty } from "./claimHistoryActionsV2";
import { navigateTo } from "./navigationActions";
import {DASHBOARD, FNOL_SUBMIT_CLAIM} from "../routes/routes";
import { PRODUCT_TYPES } from "../constants/products";
import { RISK_ITEM_TYPES } from '../constants/riskItems';
import {
    clearSelectedDamages,
    resetFNOL,
    setCoverFromPersonalInsurance,
    setStep
} from "./claimSubmitActions";

export const createCustomer = (userData: any) => {
    return async (dispatch, getState) => {
        if (userData.Email === '') {
            var email = getState().profile.email;
            userData.Email = email;
        }
        logEvent('SSP_new_client_check', {});
        dispatch({ type: LOADING_SCREEN_SHOW });
        await postToController(dispatch, 'NewMobileClientCheck', JSON.stringify(userData)).then(async (response) => {
            dispatch({ type: LOADING_SCREEN_HIDE });
            dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    name: userData.Name,
                    surname: userData.Surname,
                    cellphoneNumber: userData.CellphoneNumber,
                    idNumber: userData.IdNumber,
                    email: userData.Email,
                    itcConsent: userData.ItcConsent,
                    customerId: response.customerId,
                    activePolicies: 0,
                }
            });
        })
    }
}

//ClaimsV2 Damage report callback
export const damageReportCallBack = (Fullname: any, PhoneNumber: any, department: any, dispCallBack: boolean = true) => {
    return async (dispatch, getState) => {
        logEvent('SSP_Requested_damage_report_call_back', {});
        await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
            FirstName: Fullname,
            ContactNumber: PhoneNumber,
            MobileNumber: PhoneNumber,
            Kpcid: getState().profile.countryId === 157 ? '20000038' : '10000409',
            Status: 'ACTIVE',
            Comments: 'Digital claim - client requested breakdown of repair costs.',
            CountryId: getState().profile.countryId,
        })).then((response) => {
            if (response === true) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_GET_BACK_DAMAGE,
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                })
            }
        }).catch((err) => {
            logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
        })
    }
}

export const callMeBack = (Fullname: any, PhoneNumber: any, department: any, callTime: any, dispCallBack: boolean = true, toggleComment: string = '') => {
    return async (dispatch, getState) => {
        if (toggleComment === "portable") {
            await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: Fullname,
                ContactNumber: PhoneNumber,
                MobileNumber: PhoneNumber,
                Kpcid: '10000408',
                Status: 'ACTIVE',
                Comments: 'Callback client due to portable possessions value exceeding limit.',
                CountryId: getState().profile.countryId,
            })).then((response) => {
                if (response === true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_OK,
                            isHtml: true,
                            header: '',
                            body: "<div class='full-width'><div class='text-center ok-body'><p class='step-title mt-10px mb-20px'>" + CALL_BACK_REQUEST + "</p><p>" + CALL_ASAP + "</p></div></div>",
                        }
                    });
                }
                else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                }
            }).catch((err) => {
                logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
            })
        }
        else if (department === 'Client care') {
            logEvent('SSP_Requested_client_care_call_back', {});
            await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: Fullname,
                ContactNumber: PhoneNumber,
                MobileNumber: PhoneNumber,
                Kpcid: getState().profile.countryId === 157 ? '20000037' : (callTime === "Between 06:00 and 08:00 or 18:00 and 23:00 (after-hours)" ? '10000422' : (getState().profile.policyId === '' ? '10005' : '10000409')),
                Status: 'ACTIVE',
                Comments: (getState().profile.countryId === 157 && getState().profile.policyId != "") ? 'Policy No: ' + getState().profile.selectedPersonalPolicy?.policyNumber + ' Please call me' : 'Please call me',
                CountryId: getState().profile.countryId,
            })).then((response) => {
                if (response !== true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                    return;
                }
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        header: '',
                        body: "<div class='full-width'><div class='text-center ok-body'><p class='step-title mt-10px mb-20px'>" + CALL_BACK_REQUEST + "</p><p>" + CALL_ASAP + "</p></div></div>",
                    }
                });
            }).catch((err) => {
                logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
            })
        }
        else if (department === 'New sales') {
            logEvent('SSP_Requested_client_care_call_back', {});
            await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: Fullname,
                ContactNumber: PhoneNumber,
                MobileNumber: PhoneNumber,
                Kpcid: getState().profile.countryId === 157 ? '100097' : (callTime === "Between 06:00 and 08:00 or 18:00 and 23:00 (after-hours)" ? '10000422' : (getState().profile.policyId === '' ? '10005' : '10000409')),
                Status: 'ACTIVE',
                Comments: 'Please call for New sales',
                CountryId: getState().profile.countryId,
            })).then((response) => {
                if (response !== true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                    return;
                }
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        header: '',
                        body: "<div class='full-width'><div class='text-center ok-body'><p class='step-title mt-10px mb-20px'>" + CALL_BACK_REQUEST + "</p><p>" + CALL_ASAP + "</p></div></div>",
                    }
                });
            }).catch((err) => {
                logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
            })
        }
        else if (department === 'Claims') {
            logEvent('SSP_Requested_Claims_call_back', {});
            if (getState().profile.countryId === 157) {
                await postToController(dispatch, 'SendNamClaimsCallback', JSON.stringify({
                    PolicyId: getState().profile.policyId,
                    PolicyNumber: getState().profile.personalPolicies[0].policyNumber,
                    ClientName: Fullname,
                    Cellphone: PhoneNumber,
                    Email: getState().profile.email,
                    Kpcid: '20000038'
                })).then((response) => {
                    if (response === true && dispCallBack === true) {
                        postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                            FirstName: Fullname,
                            ContactNumber: PhoneNumber,
                            MobileNumber: PhoneNumber,
                            Kpcid: getState().profile.countryId === 157 ? '20000038' : (callTime === "Between 06:00 and 08:00 or 18:00 and 23:00 (after-hours)" ? '10000422' : (getState().profile.policyId === '' ? '10005' : '10000409')),
                            Status: 'ACTIVE',
                            Comments: getState().profile.countryId === 157 ? 'Policy No: ' + getState().profile.selectedPersonalPolicy.policyNumber + ' Please call me' : 'Please call me',
                            CountryId: getState().profile.countryId,
                        })).then((response) => {
                            if (response === true) {
                                dispatch({
                                    type: MODAL_SHOW,
                                    modalProps: {
                                        type: getState().profile.countryId === 157 ? MODAL_TYPE_NAM_OK : MODAL_TYPE_OK,
                                        isHtml: true,
                                        header: '',
                                        body: getState().profile.countryId === 157 ? "<div class='full-width'><div class='text-center ok-body'><p class='step-title mt-10px mb-20px'>" + CALL_BACK + "</p><p class='mb-10px'>" + NAM_CLAIM_THANK_YOU_CALL_BACK + "</p><p class='mb-0px font-weight-bold line-height-normal'>" + NAM_CLAIM_CALLBACK_BUSINESS_HOURS_HEADING + "</p><p class='mb-0px line-height-normal'>" + NAM_CLAIM_CALLBACK_BUSINESS_HOURS + "</p></div></div>" : "<div class='full-width'><div class='text-center ok-body'><p class='step-title mt-10px mb-20px'>" + CALL_BACK_REQUEST + "</p><p>" + CALL_ASAP + "</p></div></div>",
                                    }
                                });
                            }
                        })
                    } else if (response !== true) {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        })
                    }
                }).catch((err) => {
                    logErrorToDatabase("Error post createClaimsCallbackRequest, Error: " + err);
                })
            }
            else {

                await postToController(dispatch, 'CreateClaimsCallbackRequest', JSON.stringify({
                    PolicyId: getState().profile.policyId,
                    CustomerId: getState().profile.customerId,
                    CustomerName: Fullname,
                    PhoneNumber: PhoneNumber,
                })).then((response) => {
                    if (response === true && dispCallBack === true) {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_OK,
                                isHtml: true,
                                header: '',
                                body: "<div class='text-center'><h3>" + WELL_CALL_YOU_SOON + "</h3><p>" + CALL_YOU_ASAP + "</p></div>",
                            }
                        });
                    } else if (response !== true) {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        })
                    }
                }).catch((err) => {
                    logErrorToDatabase("Error post createClaimsCallbackRequest, Error: " + err);
                })
            }
        }
        else if (department === 'Collectable car') {
            await dispatch({ type: POLICY_LOAD_VIEW_SCREEN_SHOW })

            logEvent('SSP_Requested_collectable_car_call_back', {});
            await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: Fullname,
                ContactNumber: PhoneNumber,
                MobileNumber: PhoneNumber,
                Kpcid: getState().profile.countryId === 157 ? '20000037' : (callTime === "Between 06:00 and 08:00 or 18:00 and 23:00 (after-hours)" ? '10000422' : (getState().profile.policyId === '' ? '10005' : '10000409')),
                Status: 'ACTIVE',
                Comments: 'Please call me',
                CountryId: getState().profile.countryId,
            })).then((response) => {
                if (response === true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_INTERVENTION,
                        }

                    });
                }
                else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                }

            }).catch((err) => {
                logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
            })
            dispatch(navigateTo(DASHBOARD));
            dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE });
        }
    }
}

//Fnol callback 
export const fnolCallMeBack = (Fullname: any, PhoneNumber: any, Comments: any, department: any, dispCallBack: boolean = true) => {

    return async (dispatch, getState) => {
        if (department === "claims_consultant") {
            logEvent('SSP_Requested_Claims_call_back', {});
            await postToController(dispatch, 'CreateClaimsCallbackRequest', JSON.stringify({
                PolicyId: getState().profile.policyId,
                CustomerId: getState().profile.customerId,
                CustomerName: Fullname,
                PhoneNumber: PhoneNumber,
                CustomMessage: (Comments && typeof Comments === "string") ? Comments : '',
            })).then((response) => {
                if (response === true && dispCallBack === true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_GET_BACK_TO_YOU,
                            isHtml: true,
                            header: '',
                            body: "<div class='text-center'><h3>" + WELL_CALL_YOU_SOON + "</h3><p>" + CALL_YOU_ASAP + "</p></div>",
                        }
                    });
                } else if (response !== true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                }
            }).catch((err) => {
                logErrorToDatabase("Error post createClaimsCallbackRequest, Error: " + err);
            })
        } else if (department === "tecnical_assistance") {
            logEvent('SSP_Requested_client_care_call_back', {});
            await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: Fullname,
                ContactNumber: PhoneNumber,
                MobileNumber: PhoneNumber,
                Kpcid: '10000409',
                Status: 'ACTIVE',
                Comments: Comments,
                CountryId: getState().profile.countryId,
            })).then((response) => {
                if (response === true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_GET_BACK_TO_YOU,
                            isHtml: true,
                            header: '',
                            body: "<div class='text-center'><h3>" + WELL_CALL_YOU_SOON + "</h3><p>" + CALL_YOU_ASAP + "</p></div>",
                        }
                    });
                }
                else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                }
            }).catch((err) => {
                logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
            })
        } else if (department === "legal_advisor") {
            logEvent('SSP_Requested_client_care_call_back', {});
            await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: Fullname,
                ContactNumber: PhoneNumber,
                MobileNumber: PhoneNumber,
                Kpcid: '10000914',
                Status: 'ACTIVE',
                Comments: Comments,
                CountryId: getState().profile.countryId,
            })).then((response) => {
                if (response === true) {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_GET_BACK_TO_YOU,
                            isHtml: true,
                            header: '',
                            body: "<div class='text-center'><h3>" + WELL_CALL_YOU_SOON + "</h3><p>" + CALL_YOU_ASAP + "</p></div>",
                        }
                    });
                }
                else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    })
                }
            }).catch((err) => {
                logErrorToDatabase("Error post createExternalLeadRequest, Error: " + err);
            })
        }
    }
}

export const showProfile = () => {
    return (dispatch) => {
        dispatch({ type: PROFILE_SHOW });
    }
}

export const setSelectedPersonalPolicy = (policy) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                selectedPersonalPolicy: policy,
                selectedPersonalCover: '',
            }
        });
    }
}

export const hideProfile = () => {
    return (dispatch) => {
        dispatch({ type: PROFILE_HIDE });
    }
}

export const showMobileProfile = () => {
    return (dispatch) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                showMobileProfile: true,
            }
        });
    }
}

export const hideMobileProfile = () => {
    return (dispatch) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                showMobileProfile: false,
            }
        });
    }
}

export const toggleProfile = () => {
    return (dispatch, getState) => {
        if (getState().profile.showProfile) {
            dispatch({ type: PROFILE_HIDE });
        }
        else {
            dispatch({ type: PROFILE_SHOW });
        }
    }
}

export const infoUpdated = () => {
    return (dispatch) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                updateEditData: false,
            }
        });
    }
}

export const updateInfo = (infoField: string, infoData: string) => {
    return (dispatch,) => {
        switch (infoField) {
            case FIELD_PHONENUMBER: {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        editCellphoneNumber: infoData,
                        updateEditData: true,
                    }
                });
                break;
            }
            case FIELD_EMAIL: {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        editEmail: infoData,
                        updateEditData: true,
                    }
                });
                break;
            }
            case FIELD_ALTPHONENUMBER: {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        editAlternateNumber: infoData,
                        updateEditData: true,
                    }
                });
                break;
            }
            case FIELD_PREFERREDLANGUAGE: {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        editPreferredLanguage: infoData,
                        updateEditData: true,
                    }
                });
                break;
            }
            default:
        }
    }
}

export const updateCustomerInfo = (data: any) => {
    return async (dispatch, getState) => {
        try {
            if (data.editEmail === '') {
                var email = getState().profile.email;
                data.editEmail = email;
            }
            if (data.editAlternateNumber === '') {
                var alternateNumber = getState().profile.alternateNumber;
                data.editAlternateNumber = alternateNumber;
            }
            if (data.editPhone === '') {
                var phoneNumber = getState().profile.phoneNumber;
                data.editPhone = phoneNumber;
            }

            dispatch({ type: LOADING_SCREEN_SHOW });
            await postToController(dispatch, 'UpdateProfileContactInfo', JSON.stringify({
                CellPhone: data.editPhone,
                AlternateContactInfo: data.editAlternateNumber,
                Id: getState().profile.customerId,
                Email: data.editEmail,
            })).then(async (response) => {
                if (response) {
                    dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            email: data.editEmail,
                            cellphoneNumber: data.editPhone,
                            alternateNumber: data.editAlternateNumber,
                            editEmail: data.editEmail,
                            editCellphoneNumber: data.editPhone,
                            editAlternateNumber: data.editAlternateNumber,
                        }
                    });
                    dispatch({ type: LOADING_SCREEN_HIDE });
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_OK,
                            isHtml: true,
                            body: "<div class='text-center'><h3>Success</h3><p>" + UPDATE_CUSTOMER_INFO_SUCCESS + "</p></div>"
                        }
                    });
                } else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                }
            }).catch((err) => {
                logErrorToDatabase("Error post UpdateProfileContactInfo, Error: " + err);
            })
        }
        finally {
            dispatch({ type: LOADING_SCREEN_HIDE });
        }
    }
}

export const requestDocument = (userData: {
    Email: string;
    DocumentId: string;
    StartDate: string;
    EndDate: string;
    CoverId: string;
}) => {
    return async (dispatch, getState) => {
        logEvent('SSP_request_a_document', getState().profile.policyId);
        await postToController(dispatch, 'RequestDocument', JSON.stringify({
            Email: userData.Email,
            DocumentType: userData.DocumentId,
            PolicyId: getState().profile.policyId,
            StartDate: userData.StartDate,
            EndDate: userData.EndDate,
            CoverId: userData.CoverId
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        body: "<div class='text-center'><h3>Document sent</h3><p>" + DOCUMENT_SUCCESSFULLY_SENT + "</p></div>"
                    }
                });
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post RequestDocument, Error: " + err);
        })
    }
}

export const requestLifeDocument = (userData: {
    Email: string;
    DocumentName: string;
}) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'SendLifePolicyDocuments', JSON.stringify({
            Email: userData.Email,
            DocumentName: userData.DocumentName,
            PolicyId: getState().lifePolicy.policy.id,
        })).then(async (response) => {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_OK,
                    isHtml: true,
                    body: "<div class='text-center'><h3>Document sent</h3><p>" + DOCUMENT_SUCCESSFULLY_SENT + "</p></div>"
                }
            });
        }).catch((err) => {
            logErrorToDatabase("Error post RequestDocument, Error: " + err);
        })
    }
}

export const requestDocumentCover = (userData: {
    Email: string;
    DocumentId: string;
    CoverId: string;
}) => {
    return async (dispatch, getState) => {
        logEvent('SSP_request_a_document', getState().profile.policyId);
        await postToController(dispatch, 'RequestDocument', JSON.stringify({
            Email: userData.Email,
            DocumentType: userData.DocumentId,
            PolicyId: getState().profile.policyId,
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        body: "<div class='text-center'><h3>Document sent</h3><p>" + DOCUMENT_SUCCESSFULLY_SENT + "</p></div>"
                    }
                });
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post RequestDocument, Error: " + err);
        })
    }
}

export const requestDocumentDate = (userData: {
    Email: string;
    DocumentId: string;
    StartDate: string;
    EndDate: string;
}) => {
    return async (dispatch, getState) => {
        logEvent('SSP_request_a_document', getState().profile.policyId);
        await postToController(dispatch, 'RequestDocument', JSON.stringify({
            Email: userData.Email,
            DocumentType: userData.DocumentId,
            PolicyId: getState().profile.policyId,
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        body: "<div class='text-center'><h3>Document sent</h3><p>" + DOCUMENT_SUCCESSFULLY_SENT + "</p></div>"
                    }
                });
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post RequestDocument, Error: " + err);
        })
    }
}

export function setSelectedCoverType(type) {
    return async (dispatch, getState) => {
        await dispatch({ type: SET_CUSTOMER_DATA, payload: { selectedPersonalCoverType: type } });
    }
}

export function setSelectedCover(coverId) {
    return async (dispatch, getState) => {
        var policies = getState().profile.selectedPersonalPolicy;
        let selectedCover : any = null;
        if (policies !== undefined) {
            for (var i = 0; i < policies.covers.length; i++) {
                var cover = policies.covers[i];
                if (cover.isMainline === true && cover.id === coverId) {
                    selectedCover = cover;
                    break;
                }

                if (coverId !== EMPTY_GUID){
                    for (var j = 0; j < cover.riskItems.length; j++) {
                        var riskItem = cover.riskItems[j];
                        if (riskItem.riskItemId == coverId) {
                            selectedCover = cover;
                            break;
                        }
                    };
                }
            };

        }

        if (selectedCover !== null) {
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    selectedPersonalCover: selectedCover,
                    selectedPersonalQuotedCover: null,
                    selectedPersonalCoverType: POLICY_COVER_ITEM
                }
            });
        }
    }
}

export function setSelectedQuotedCover(quoteCoverId) {
    return async (dispatch, getState) => { 
        var quotedItems = getState().profile.quotedFutureItems;
        if (quotedItems) {
            for (var i = 0; i < quotedItems.length; i++) {
                var qi = quotedItems[i];
                if (qi.id === quoteCoverId) {
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalQuotedCover: qi,
                            selectedPersonalCover: dispatch(convertQuoteCoverToPolicyCover(qi)),
                            selectedPersonalCoverType: QUOTED_COVER_ITEM
                        }
                    });
                    break;
                }
            }
        }
    }
}

export function setSelectedClaim(claimId) {
    return async (dispatch, getState) => {
        var claims = getState().profile.personalClaims;
        let selectedClaim = null;
        if (claims !== undefined) {
            for (var i = 0; i < claims.length; i++) {
                var claim = claims[i];
                if (claim.claimNumber === claimId) {
                    selectedClaim = claim;
                    break;
                }
            };
        }
        if (selectedClaim !== null && selectedClaim !== "") {
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    selectedPersonalClaim: selectedClaim,
                }
            });

            await dispatch({
                type: SET_CLAIM_DATA, payload: {
                    selectedClaim: selectedClaim
                }
            });

            await dispatch(getClaimProgress(getState().claimSubmit.selectedClaim.claimID));
            await dispatch(getNextProgressStepName());
            await dispatch(setLoadingAndEmpty(false, false))
        }
        else {
            await dispatch(setLoadingAndEmpty(false, true))
        }
    }
}

export function setSelectedLifeCover(props) {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                selectedLifeCover: props,
            }
        });
    }
}

export const updateBankingDetails = (userData: any) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'UpdateBankingDetails', JSON.stringify({
            BankAccountId: getState().profile.bankingDetails.id,
            CustomerId: getState().profile.customerId,
            TotalPremium: getState().profile.selectedPersonalPolicy.totalPolicyPremium,
            BankAccountTypeId: userData.selectedAccountType.id,
            BankId: userData.selectedBank.id,
            BranchId: userData.selectedBranch.id,
            AccountNumber: userData.editAccountNumber,
            Accountholder: userData.editHolder,
            IsPolicyHolder: true,
            AccountHolderIdNumber: getState().profile.idNumber
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        body: "<div class='text-center'><h3>Success</h3><p>" + UPDATE_CUSTOMER_INFO_SUCCESS + "</p></div>"
                    }
                });
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post UpdateBankingDetails, Error: " + err);
        })
    }
}

export const addBankingDetails = (userData: any) => {
    return async (dispatch, getState) => {
        logEvent('SSP_add_banking_details', {});
        await postToController(dispatch, 'AddBankingDetails', JSON.stringify({
            CustomerId: getState().profile.customerId,
            BankAccountTypeId: userData.selectedAccountType.id,
            BankId: userData.selectedBank.id,
            BranchId: userData.selectedBranch.id,
            AccountNumber: userData.accountNumber,
            AccountHolder: getState().profile.name,
            AccountHolderIdNumber: getState().profile.idNumber,
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_OK,
                        isHtml: true,
                        body: "<div class='text-center'><h3>Success</h3><p>" + UPDATE_CUSTOMER_INFO_SUCCESS + "</p></div>"
                    }
                });
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post AddBankingDetails, Error: " + err);
        })
    }
}

export const getUserBankingDetails = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetBankingDetails', JSON.stringify({
            PolicyId: getState().profile.policyId,
            QuoteId: "00000000-0000-0000-0000-000000000000"
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        bankingDetails: response,
                    }
                })
            }
        }).catch((err) => {
            logErrorToDatabase("Error post GetBankingDetails, Error: " + err);
        })
    }
}

export const updatePolicyEditState = (isInEdit) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                updatePolicy: isInEdit,
            }
        })
    }
}

export const setCustomerData = (data) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: data
        })
    }
}

export const setSelfInspectStep = (data) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                selfInspectionStep: data,
            }
        })
    }
}

export const resetEditPersonalDeets = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                editCellphoneNumber: getState().profile.cellphoneNumber,
                editEmail: getState().profile.email,
                editAlternateNumber: getState().profile.alternateNumber,
                editPreferredLanguage: getState().profile.preferredLanguage,
            }
        });
    }
}

export const copyToEdit = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                editCellphoneNumber: getState().profile.cellphoneNumber,
                editEmail: getState().profile.email,
                editAlternateNumber: getState().profile.alternateNumber,
                editPreferredLanguage: getState().profile.preferredLanguage,
            }
        });
    }
}

export const dataUpdated = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                updateEditData: false
            }
        });
    }
}

export const setSpecialDebitData = (HasSpecialDebit, SpecialDebitDate) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                hasSpecialDebitDate: HasSpecialDebit,
                specialDebitDate: SpecialDebitDate,
            }
        });
    }
}

export const setGoToSpecialDebitSchedule = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                goToSchedule: true
            }
        });
    }
}

export const setSelectedSpecialDebitDate = (scheduledDate) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                selectedSpecialDebit: true,
                scheduledSpecialDebitDate: scheduledDate,
            }
        });
    }
}

export const checkSpecialDebitDate = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'CanAddSpecialDebit', JSON.stringify({
            Parameter: getState().profile.policyId
        }))
            .then(async Response => {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload:
                    {
                        hasSpecialDebitDate: Response.canAddSpecialDebit,
                        specialDebitDate: Response.specialDebitDate,
                        specialDebitAmount: Response.specialDebitAmount,
                        specialDebitDays: Response.dateText,
                    }
                });
            }
            )
    }
}

export const submitScheduleSpecialDebit = (scheduledDate) => {
    var dateStr = scheduledDate[0].day + " " + scheduledDate[0].monthString + " " + scheduledDate[0].year;
    return async (dispatch, getState) => {
        logEvent('SSP_raise_special_debit', {});
        await postToController(dispatch, 'RaiseSpecialDebitOnPolicy', JSON.stringify({
            PolicyId: getState().profile.policyId,
            Day: Number(getState().profile.scheduledSpecialDebitDate[0].day),
            Month: Number(getState().profile.scheduledSpecialDebitDate[0].month),
            Year: Number(getState().profile.scheduledSpecialDebitDate[0].year),
            SpecialDebitAmount: Number(getState().profile.specialDebitAmount),
            BankAccountId: getState().profile.bankingDetails.id,
            DebitOrderDay: 15,
        })).then(async response => {
            if (response != "Failure") {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        scheduledSpecialDebitDate: scheduledDate,
                        hasScheduledSpecialDebit: true,
                        goToSchedule: false,
                        specialDebitDate: dateStr,
                    }
                })
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error post RaiseSpecialDebitOnPolicy, Error: " + err);
        })
    }
}

export const setPolicyReducer = (type, name, value) => {
    return async (dispatch) => {
        await dispatch({
            type: type, payload: {
                [name]: value
            }
        });
    }
}

export const getRiskItemType = (riskItemType: number) => {
    return (dispatch) => {
        let type: any = null;
        switch (riskItemType) {
            case RISK_ITEM_TYPES.PortablePossessions.Id: { type = RISK_ITEM_TYPES.PortablePossessions; break; }
            case RISK_ITEM_TYPES.Caravans.Id: { type = RISK_ITEM_TYPES.Caravans; break; }
            case RISK_ITEM_TYPES.Trailers.Id: { type = RISK_ITEM_TYPES.Trailers; break; }
            case RISK_ITEM_TYPES.HomeContents.Id: { type = RISK_ITEM_TYPES.HomeContents; break; }
            case RISK_ITEM_TYPES.Buildings.Id: { type = RISK_ITEM_TYPES.Buildings; break; }
            case RISK_ITEM_TYPES.Cars.Id: { type = RISK_ITEM_TYPES.Cars; break; }
            case RISK_ITEM_TYPES.Motorbikes.Id: { type = RISK_ITEM_TYPES.Motorbikes; break; }
            case RISK_ITEM_TYPES.Watercraft.Id: { type = RISK_ITEM_TYPES.Watercraft; break; }
            case RISK_ITEM_TYPES.Cyber.Id: { type = RISK_ITEM_TYPES.Cyber; break; }
            case RISK_ITEM_TYPES.Warranty.Id: { type = RISK_ITEM_TYPES.Warranty; break; }
            case RISK_ITEM_TYPES.PersonalAccident.Id: { type = RISK_ITEM_TYPES.PersonalAccident; break; }
            case RISK_ITEM_TYPES.EmergencyService.Id: { type = RISK_ITEM_TYPES.EmergencyService; break; }
            case RISK_ITEM_TYPES.Pet.Id: { type = RISK_ITEM_TYPES.Pet; break; }
            case RISK_ITEM_TYPES.AccidentInsurance.Id: { type = RISK_ITEM_TYPES.AccidentInsurance; break; }
        }
        return type;
    }
}

export const convertQuoteCoverToPolicyCover = (cover: any) => {
    return (dispatch, getState) => {
        const mainCoverItem = cover.quoteCovers.filter(x => x.product.productType === PRODUCT_TYPES.PersonalLines)[0];
        const product = mainCoverItem.product;
        const riskItemType = dispatch(getRiskItemType(product.riskItemType));

        let coverItem = {
            id: cover.id,
            isMainline: true,
            image: riskItemType.Image,
            excess: mainCoverItem.excess,
            productId: mainCoverItem.productId,
            productName: product.name,
            product: riskItemType.Product,
            riskItems: [
                {
                    id: cover.Id,
                    riskItemId: cover.quoteRiskItem.quoteRiskItemLinkingId,
                    description: cover.quoteRiskItem.description,
                    coverStartDate: mainCoverItem.inceptionDate,
                    premium: cover.grossPremium,
                    excess: mainCoverItem.excess,
                    chilliDetails: {
                        riskItemId: cover.quoteRiskItem.quoteRiskItemLinkingId,
                    },
                    hasError: false,
                }
            ],
            accessories: [],
            accessoriesTotal: 0,
            vaps: [],
            policyCoverId: ""
        }
        return coverItem;
    }
}